var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIndicator1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "94.929px",
    height: "8.404px",
    viewBox: "36.226 11.346 94.929 8.404",
    enableBackground: "new 36.226 11.346 94.929 8.404",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.432,16.24h-3.654v-1.385h3.654V16.24z M114.627,16.24h-4.148v-1.385h4.148V16.24z M106.328,16.24 h-4.15v-1.385h4.15V16.24z M98.027,16.24h-4.15v-1.385h4.15V16.24z M89.729,16.24h-4.15v-1.385h4.15V16.24z M81.428,16.24h-4.15 v-1.385h4.15V16.24z M73.127,16.24h-4.15v-1.385h4.15V16.24z M64.828,16.24h-4.15v-1.385h4.15V16.24z M56.528,16.24h-4.15v-1.385 h4.15V16.24z M48.228,16.24h-4.15v-1.385h4.15V16.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 40.92,
    cy: 15.548,
    r: 4.154
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 126.459,
    cy: 15.548,
    r: 4.154
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIndicator1);
export default __webpack_public_path__ + "static/media/line-indicator1.03109fa7b3acd4440c8a36636342f076.svg";
export { ForwardRef as ReactComponent };